import { Link } from 'react-router-dom';

import { MatterList } from './components/matter-list';
import { Icon } from '../../components/icon';
import { useGetUserCases } from '@/api/queries/useGetUserCases';
import { useUserContext } from '@/Contexts/User';
import { Breadcrumb } from '@/new/components/breadcrumb';
import { PageContainer } from '@/new/components/page-container';
import { PageHeader } from '@/new/components/page-header';
import { PageTitle } from '@/new/components/page-title';
import { Button } from '@/new/components/shadcn/button';

export function Matters() {
  const { user } = useUserContext();
  if (!user) return null;
  const { data: cases } = useGetUserCases(user.id);

  return (
    <>
      <Breadcrumb items={[{ href: '/matters', label: 'Matters', active: true }]} />

      <PageContainer>
        <PageHeader>
          <PageTitle text="Matters" />
          <Link to="/create-matter">
            <Button variant="primary">
              <Icon className="lucide--book-plus" />
              Create a New Matter
            </Button>
          </Link>
        </PageHeader>

        <MatterList matters={cases} />
      </PageContainer>
    </>
  );
}
